import React from 'react';

import Loading from 'components/Loading';
import { BlackCanvas } from './Loader.style';
import { CanvasContainer, FooterContainer, TitleContainer } from '../Canvas/Canvas.style';

const Loader = () => (
  <CanvasContainer>
    <TitleContainer />
    <BlackCanvas>
      <Loading size={70} color="#222" ariaLabel="Loading viewer" />
    </BlackCanvas>
    <FooterContainer />
  </CanvasContainer>
);

export default Loader;
